<div class="container-wrapper" [@routeAnimations]="prepareRoute(outlet)">
  <div class="main-container" id="main-container">
    <app-header></app-header>
    <main>
      <router-outlet #outlet="outlet"></router-outlet>
    </main>
  </div>
  <app-footer id="footer"></app-footer>
</div>
<app-snacks></app-snacks>
